import { cva } from 'class-variance-authority';
import { Colors } from '@/lib/colorUtils';

export enum DotLoaderSize {
  small = 'small',
  medium = 'medium',
  large = 'large',
}

export type DotLoaderProps = {
  size?: DotLoaderSize;
  color?: Colors;
  /** Test hook placed on the root element. Defaults to `"dot-loader"` (PB-3325). */
  'data-cy'?: string;
};

export const loaderWrapperVariants = cva('tw:inline-flex tw:items-center tw:justify-center', {
  variants: {
    size: {
      small: 'tw:gap-[0.25rem]',
      medium: 'tw:gap-micro',
      large: 'tw:gap-[0.9375rem]',
    },
  },
  defaultVariants: {
    size: 'medium',
  },
});

export const dotVariants = cva(
  'tw:inline-block tw:rounded-full tw:animate-dot-pulse tw:motion-reduce:animate-none tw:motion-reduce:opacity-80',
  {
    variants: {
      size: {
        small: 'tw:w-[0.3125rem] tw:h-[0.3125rem]',
        medium: 'tw:w-[0.625rem] tw:h-[0.625rem]',
        large: 'tw:w-[1.25rem] tw:h-[1.25rem]',
      },
    },
    defaultVariants: {
      size: 'medium',
    },
  }
);
